// GeoData hierarchy (Levent, 8 Oct 2026): a city of a country that is OFF, or a zone of a city or
// country that is OFF, is effectively off — its hotels are not sold. Its own saved setting is kept
// and applies again when the parent is switched back ON, so the pages show the effective state
// and the own setting beside it instead of overwriting anything.
const isOff = (v) => v === 0 || v === false || v === "0";

/** Why this row is off through a parent ("country" / "city"), or null when its parents are ON. */
export function parentOff(row) {
  if (isOff(row?.countryActive)) return "country";
  if (isOff(row?.destinationActive)) return "city";
  return null;
}

export default parentOff;
